var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionSplit',{staticClass:"full-image reverse",attrs:{"id":"SectionOptimisedSystem","headline":_vm.$t('headline'),"src":"../../assets/optimised-system.jpg"}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('text'))+" ")]),_c('Btn',{attrs:{"to":_vm.ctaTo}},[_vm._v(" "+_vm._s(_vm.$t('cta'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }